// extracted by mini-css-extract-plugin
export default {"secondaryActionsButtons":"DeletePendingPaymentsModal_secondaryActionsButtons__YtvQh"};